import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LIST_DEFAULT_PAGE_SIZE } from "../utils/constants";
import {
  // ChangeHospitalRoomTypePutRequest,
  ChangeByFilterPutRequest,
  deleteTPAPatientBills,
  DownloadTPABillItems,
  GetAllSchemesData,
  GetHospitalRoomTypeData,
  getTPABillList,
  GetTPADSBillCompData,
  GetTPAMappedCollections,
  GetTPARoomTypeData,
  TpaBillGetRequest,
  TpaBillPostRequest,
  TpaBillPutRequest,
} from "../apis/TPABillingService";
import {
  Document,
  ITPABillHeaderRequest,
  ITPABillItemsRequest,
} from "../interfaces/ITPABills";
import {
  ChangeWardTypePutRequest,
  ChangeWardTypePutRequestNew,
  deleteGovtPatientBills,
  getGovtBillList,
  GetGovtDSBillCompData,
  GetGovtMappedCollections,
  GovtBillGetRequest,
  GovtBillPostRequest,
  GovtBillPutRequest,
} from "../apis/govtBillingService";

interface IBillState {
  loaders: any;
  pageToBillsList: { [key: number]: Array<any> };
  billsListFilters: any;
  billsListCurrState: any;
  pageToPatientBillsList: any;
  patientBillsListFilters: any;
  patientBillsListCurrState: any;
  tpaBill: any;
  govtBill: any;
}
const initialState: IBillState = {
  loaders: {
    isFetchingBillsList: false,
    isFetchingPatientBillsList: false,
  },
  pageToBillsList: {},
  pageToPatientBillsList: {},
  billsListFilters: {
    orderBy: "DESC",
    pageNumber: 1,
    pageSize: LIST_DEFAULT_PAGE_SIZE,
    caseType: "",
    startDate: "",
    endDate: "",
    billType: "",
    scheme: "",
    billStatus: "",
    searchTerm: "",
  },
  patientBillsListFilters: {
    pageNumber: 1,
    pageSize: LIST_DEFAULT_PAGE_SIZE,
  },
  billsListCurrState: {
    totalElements: 0,
  },
  patientBillsListCurrState: {
    totalElements: 0,
  },
  tpaBill: {},
  govtBill: {
    govtBillFilters: {},
  },
};
//function to get bill list
// export const fetchBillsList = createAsyncThunk(
//   "bills/fetchBillsList",
//   async (thunkAPI) => {
//     try {
//       const response = await Axios.get(
//         `${process.env.REACT_APP_API_URL}/bills`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

export const TpaBillGenerateRequest = createAsyncThunk(
  "billing/TpaBillGenerateRequest",
  async ({
    healthCareId,
    caseId,
    visitId,
    schemeMetaDataId,
    documentPaths,
  }: {
    healthCareId: number | undefined;
    caseId: number | undefined;
    visitId: number | undefined;
    schemeMetaDataId: number | undefined;
    documentPaths: Array<Document>;
  }) => {
    if (!healthCareId || !caseId || !visitId || !schemeMetaDataId) return;
    const reponse = await TpaBillPostRequest(
      healthCareId,
      caseId,
      visitId,
      schemeMetaDataId,
      documentPaths
    );
    return reponse;
  }
);

export const TpaBillFetchRequest = createAsyncThunk(
  "billing/TpaBillFetchRequest",
  async ({
    healthCareId,
    tpaBillMappingId,
  }: {
    healthCareId: number;
    tpaBillMappingId: number;
  }) => {
    const reponse = await TpaBillGetRequest(healthCareId, tpaBillMappingId);
    return reponse;
  }
);

export const TpaBillUpdateRequest = createAsyncThunk(
  "billing/TpaBillUpdateRequest",
  async ({
    healthCareId,
    caseId,
    visitId,
    schemeMetaDataId,
    tpaBillMappingId,
    tpaBillHeaderRequest,
    tpaBillItemsRequests,
  }: {
    healthCareId: number;
    caseId: number;
    visitId: number;
    schemeMetaDataId: number;
    tpaBillMappingId: number;
    tpaBillHeaderRequest: ITPABillHeaderRequest;
    tpaBillItemsRequests: Array<ITPABillItemsRequest>;
  }) => {
    const reponse = await TpaBillPutRequest(
      healthCareId,
      caseId,
      visitId,
      schemeMetaDataId,
      tpaBillMappingId,
      tpaBillHeaderRequest,
      tpaBillItemsRequests
    );
    return reponse;
  }
);

export const updateBillStatus = createAsyncThunk(
  "billing/updateBillStatus",
  async ({
    healthCareId,
    caseId,
    visitId,
    schemeMetaDataId,
    tpaBillMappingId,
    tpaBillHeaderRequest,
    tpaBillItemsRequests,
  }: {
    healthCareId: number;
    caseId: number;
    visitId: number;
    schemeMetaDataId: number;
    tpaBillMappingId: number;
    tpaBillHeaderRequest: ITPABillHeaderRequest;
    tpaBillItemsRequests: Array<ITPABillItemsRequest>;
  }) => {
    const response = await TpaBillPutRequest(
      healthCareId,
      caseId,
      visitId,
      schemeMetaDataId,
      tpaBillMappingId,
      tpaBillHeaderRequest,
      tpaBillItemsRequests
    );
    return response;
  }
);

export const updateBillByFilter = createAsyncThunk(
  "billing/updateBillByFilter",
  async ({
    tpaBillMappingId,
    healthCareId,
    schemeMetaDataId,
    roomType,
    hospitalRoomType,
    filterBy,
  }: {
    tpaBillMappingId: number;
    healthCareId: number;
    schemeMetaDataId: number;
    roomType?: string;
    hospitalRoomType?: string;
    filterBy?: string;
  }) => {
    const response = await ChangeByFilterPutRequest(
      tpaBillMappingId,
      healthCareId,
      schemeMetaDataId,
      roomType,
      hospitalRoomType,
      filterBy
    );
    return response;
  }
);

// export const updateBillHospitalRoomType = createAsyncThunk(
//   "billing/updateBillHospitalRoomType",
//   async ({
//     tpaBillMappingId,
//     healthCareId,
//     schemeMetaDataId,
//     hospitalRoomType,
//   }: {
//     tpaBillMappingId: number;
//     healthCareId: number;
//     schemeMetaDataId: number;
//     hospitalRoomType: string;
//   }) => {
//     const response = await ChangeHospitalRoomTypePutRequest(
//       tpaBillMappingId,
//       healthCareId,
//       schemeMetaDataId,
//       hospitalRoomType
//     );
//     return response;
//   }
// );

export const fetchTPABillList = createAsyncThunk(
  "billing/fetchTPABillList",
  async ({
    healthCareId,
    caseId,
    visitId,
    filters,
  }: {
    healthCareId: number;
    caseId: number;
    visitId: number;
    filters: any;
  }) => {
    const response = await getTPABillList(
      healthCareId,
      caseId,
      visitId,
      filters
    );
    return response;
  }
);

export const DownloadTPABillItemsList = createAsyncThunk(
  "billing/DownloadTPABillItemsList",
  async ({
    tpaBillMappingId,
    type,
  }: {
    tpaBillMappingId: number;
    type: string;
  }) => {
    const reponse = await DownloadTPABillItems(tpaBillMappingId, type);
    return reponse;
  }
);

export const GetTPAMappedCategories = createAsyncThunk(
  "billing/GetTPAMappedCategories",
  async () => {
    const reponse = await GetTPAMappedCollections();
    return reponse;
  }
);

export const DeletePatientBillsTPA = createAsyncThunk(
  "billing/DeletePatientBillsTPA",
  async (tpaBillIdsToDelete: number[]) => {
    const reponse = await deleteTPAPatientBills(tpaBillIdsToDelete);
    return reponse;
  }
);

export const DeletePatientBillsGovt = createAsyncThunk(
  "billing/DeletePatientBillsGovt",
  async (govtBillIdsToDelete: number[]) => {
    const reponse = await deleteGovtPatientBills(govtBillIdsToDelete);
    return reponse;
  }
);

export const fetchTPARoomTypeData = createAsyncThunk(
  "billing/fetchTPARoomTypeData",
  async ({
    healthCareId,
    schemeMetaDataId,
  }: {
    healthCareId: number;
    schemeMetaDataId: number;
  }) => {
    const response = await GetTPARoomTypeData(healthCareId, schemeMetaDataId);
    return response;
  }
);

export const fetchHospitalRoomTypeData = createAsyncThunk(
  "billing/fetchHospitalRoomTypeData",
  async ({
    healthCareId,
  }: // schemeMetaDataId,
  {
    healthCareId: number;
    // schemeMetaDataId: number;
  }) => {
    const response = await GetHospitalRoomTypeData(healthCareId);
    return response;
  }
);

export const fetchAllSchemesData = createAsyncThunk(
  "billing/fetchAllSchemesData",
  async ({ healthCareId }: { healthCareId: number }) => {
    const response = await GetAllSchemesData(healthCareId);
    return response;
  }
);

export const FetchTPADSBillCompData = createAsyncThunk(
  "billing/FetchTPADSBillCompData",
  async ({ tpaBillMappingId }: { tpaBillMappingId: number }) => {
    const reponse = await GetTPADSBillCompData(tpaBillMappingId);
    return reponse;
  }
);

export const GovtBillGenerateRequest = createAsyncThunk(
  "billing/GovtBillGenerateRequest",
  async ({
    healthCareId,
    patientId,
    caseId,
    visitId,
    schemeMetaDataId,
    patientName,
    documentPaths,
  }: {
    healthCareId: number | undefined;
    patientId: any | undefined;
    caseId: number | undefined;
    visitId: number | undefined;
    schemeMetaDataId: number | undefined;
    patientName: string | undefined;
    documentPaths: any;
  }) => {
    if (
      !healthCareId ||
      !patientId ||
      !caseId ||
      !visitId ||
      !schemeMetaDataId ||
      !patientName
    )
      return;
    const reponse = await GovtBillPostRequest(
      healthCareId,
      patientId,
      caseId,
      visitId,
      schemeMetaDataId,
      patientName,
      documentPaths
    );
    return reponse;
  }
);

export const GovtBillFetchRequest = createAsyncThunk(
  "billing/GovtBillFetchRequest",
  async ({
    healthCareId,
    govtBillMappingId,
  }: {
    healthCareId: number;
    govtBillMappingId: number;
  }) => {
    const reponse = await GovtBillGetRequest(healthCareId, govtBillMappingId);
    return reponse;
  }
);

export const GovtBillUpdateRequest = createAsyncThunk(
  "billing/GovtBillUpdateRequest",
  async ({
    govtBillHeaderRequest,
    govtBillItemsRequests,
  }: {
    govtBillHeaderRequest: any;
    govtBillItemsRequests: any;
  }) => {
    const reponse = await GovtBillPutRequest(
      govtBillHeaderRequest,
      govtBillItemsRequests
    );
    return reponse;
  }
);

export const updateGovtBillStatus = createAsyncThunk(
  "billing/updateGovtBillStatus",
  async ({
    govtBillHeaderRequest,
    govtBillItemsRequests,
  }: {
    govtBillHeaderRequest: any;
    govtBillItemsRequests: any;
  }) => {
    const response = await GovtBillPutRequest(
      govtBillHeaderRequest,
      govtBillItemsRequests
    );
    return response;
  }
);

export const updateBillWardType = createAsyncThunk(
  "billing/updateBillWardType",
  async ({
    govtBillMappingId,
    healthCareId,
    schemeMetaDataId,
    wardType,
  }: {
    govtBillMappingId: number;
    healthCareId: number;
    schemeMetaDataId: number;
    wardType: string;
  }) => {
    const response = await ChangeWardTypePutRequest(
      govtBillMappingId,
      healthCareId,
      schemeMetaDataId,
      wardType
    );
    return response;
  }
);

export const updateBillWardTypeNew = createAsyncThunk(
  "billing/updateBillWardTypeNew",
  async ({
    govtBillMappingId,
    hospitalAccreditation,
    labAccreditation,
    wardType,
  }: {
    govtBillMappingId: number;
    hospitalAccreditation: string;
    labAccreditation: string;
    wardType: string;
  }) => {
    const response = await ChangeWardTypePutRequestNew(
      govtBillMappingId,
      hospitalAccreditation,
      labAccreditation,
      wardType
    );
    return response;
  }
);

export const fetchGovtBillList = createAsyncThunk(
  "billing/fetchGovtBillList",
  async ({
    healthCareId,
    caseId,
    visitId,
    filters,
  }: {
    healthCareId: number;
    caseId: number;
    visitId: number;
    filters: any;
  }) => {
    const response = await getGovtBillList(
      healthCareId,
      caseId,
      visitId,
      filters
    );
    return response;
  }
);

export const FetchGovtDSBillCompData = createAsyncThunk(
  "billing/FetchGovtDSBillCompData",
  async ({ govtBillMappingId }: { govtBillMappingId: number }) => {
    const reponse = await GetGovtDSBillCompData(govtBillMappingId);
    return reponse;
  }
);

export const GetGovtMappedCategories = createAsyncThunk(
  "billing/GetGovtMappedCategories",
  async () => {
    const reponse = await GetGovtMappedCollections();
    return reponse;
  }
);

const billsSlice = createSlice({
  name: "bills",
  initialState,
  reducers: {
    // resetPageToBillsList: (state) => {
    //   state.pageToBillsList = {};
    // },
    // updateBillsListFilters: (state, action) => {
    //   state.billsListFilters = action.payload.filters;
    // },
    updatePatientBillsListFilters: (state, action) => {
      state.patientBillsListFilters = action.payload.filters;
    },
    resetPageToPatientBillsList: (state) => {
      state.pageToPatientBillsList = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTPABillList.pending, (state) => {
        state.loaders.isFetchingPatientBillsList = true;
      })
      .addCase(fetchTPABillList.fulfilled, (state, action) => {
        state.loaders.isFetchingPatientBillsList = false;
        state.pageToPatientBillsList = {};
        state.patientBillsListCurrState.totalElements =
          action?.payload?.data?.paginationResponse?.totalElements || 1;
        state.patientBillsListFilters.pageNumber =
          action?.payload?.data?.paginationResponse?.pageNumber + 1 || 1;
        state.patientBillsListFilters.pageSize =
          action?.payload?.data?.paginationResponse?.pageSize ||
          LIST_DEFAULT_PAGE_SIZE;
        action?.payload?.data?.tpaBillMappingEntityResponse?.forEach(
          (bill: any) => {
            if (
              state.pageToPatientBillsList.hasOwnProperty(
                state.patientBillsListFilters.pageNumber
              )
            ) {
              state.pageToPatientBillsList[
                state.patientBillsListFilters.pageNumber
              ].push(bill);
            } else {
              state.pageToPatientBillsList[
                state.patientBillsListFilters.pageNumber
              ] = [bill];
            }
          }
        );
      })
      .addCase(fetchTPABillList.rejected, (state) => {
        state.loaders.isFetchingPatientBillsList = false;
      })
      // .addCase(fetchTPABillList.pending, (state) => {
      //   // state.loaders.isFetchingTPABillList = true;
      //   state.loaders.isFetchingPatientBillsList = true;
      // })
      // .addCase(fetchTPABillList.fulfilled, (state, action) => {
      //   state.loaders.isFetchingTPABillList = false;
      //   state.pageToBillsList = {};
      //   //reset pageToBillsList
      //   state.billsListCurrState.totalElements =
      //     action.payload?.data?.paginationResponse?.totalElements || 1;
      //   state.billsListFilters.pageNumber =
      //     action.payload?.data?.paginationResponse?.pageNumber + 1 || 1;
      //   state.billsListFilters.pageSize =
      //     action.payload?.data?.paginationResponse?.pageSize ||
      //     LIST_DEFAULT_PAGE_SIZE;
      //   action.payload?.data?.tpaBillMappingEntityResponse?.forEach(
      //     (bill: any) => {
      //       if (
      //         state.pageToBillsList.hasOwnProperty(
      //           state.billsListFilters.pageNumber
      //         )
      //       ) {
      //         state.pageToBillsList[state.billsListFilters.pageNumber].push(
      //           bill
      //         );
      //       } else {
      //         state.pageToBillsList[state.billsListFilters.pageNumber] = [bill];
      //       }
      //     }
      //   );
      // })
      // .addCase(fetchTPABillList.rejected, (state) => {
      //   state.loaders.isFetchingTPABillList = false;
      // })
      .addCase(fetchGovtBillList.pending, (state) => {
        state.loaders.isFetchingPatientBillsList = true;
      })
      .addCase(fetchGovtBillList.fulfilled, (state, action) => {
        state.loaders.isFetchingPatientBillsList = false;
        state.pageToPatientBillsList = {};
        state.patientBillsListCurrState.totalElements =
          action?.payload?.data?.paginationResponse?.totalElements || 1;
        state.patientBillsListFilters.pageNumber =
          action?.payload?.data?.paginationResponse?.pageNumber + 1 || 1;
        state.patientBillsListFilters.pageSize =
          action?.payload?.data?.paginationResponse?.pageSize ||
          LIST_DEFAULT_PAGE_SIZE;

        action?.payload?.data?.billMappingResponseList?.forEach((bill: any) => {
          if (
            state.pageToPatientBillsList.hasOwnProperty(
              state.patientBillsListFilters.pageNumber
            )
          ) {
            state.pageToPatientBillsList[
              state.patientBillsListFilters.pageNumber
            ].push(bill);
          } else {
            state.pageToPatientBillsList[
              state.patientBillsListFilters.pageNumber
            ] = [bill];
          }
        });
      })
      .addCase(fetchGovtBillList.rejected, (state) => {
        state.loaders.isFetchingPatientBillsList = false;
      });
  },
});
export const {
  // resetPageToBillsList,
  // updateBillsListFilters,
  resetPageToPatientBillsList,
  updatePatientBillsListFilters,
} = billsSlice.actions;
export default billsSlice.reducer;
